/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

const userTypeGtm = 'NewUser';
const arr: Record<string, unknown>[] = [];

/**
 * Adds GTM script to the page with a dynamic container ID
 * @param gtmId - GTM container ID (e.g., 'GTM-5V6MPZT')
 */
export const addGtmScript = (gtmId?: string) => {
  if (typeof window === 'undefined') {
    return Promise.reject();
  }

  const containerId = gtmId || '';

  return new Promise<void>((resolve) => {
    // ✅ 1. Pre-initialize data layer
    window.gtmDataLayer = window.gtmDataLayer || [];

    // ✅ 2. Push gtm.start safely
    window.gtmDataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    // ✅ 3. Load GTM script with dynamic container ID
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}&l=gtmDataLayer`;

    script.onload = () => resolve();
    document.head.appendChild(script);
  });
};

// Reset the keys just pushed so stale values don't leak into the next event.
const clearGtmKeys = (gtmData: Record<string, unknown>): void => {
  if (!window?.gtmDataLayer) {
    return;
  }
  const cleanup: Record<string, null> = {};
  Object.keys(gtmData).forEach((key) => {
    // Keep `event` (the trigger) so this reset push doesn't re-fire the tag.
    if (key !== 'event') {
      cleanup[key] = null;
    }
  });
  if (Object.keys(cleanup).length > 0) {
    window.gtmDataLayer.push(cleanup);
  }
};

export const fireGtmEvent = (gtmData: Record<string, unknown>): void => {
  if (typeof window !== 'undefined') {
    gtmData = JSON.parse(
      JSON.stringify(gtmData).replace(`{{user}}`, userTypeGtm),
    );

    if (window?.gtmDataLayer) {
      window.gtmDataLayer.push(gtmData);
      clearGtmKeys(gtmData);
    } else {
      arr.push(gtmData);
    }
  }
};

export const fireGtmEventforSRR = (): void => {
  if (window?.gtmDataLayer) {
    arr.forEach((element) => {
      window.gtmDataLayer.push(element);
      clearGtmKeys(element);
    });
    arr.splice(0, arr.length);
  }
};
